import { ExplorerMemo, Toolbar, FileExplorerCallbacks  } from "@sandbox/code-editor";
import { useMemo, useState } from "react";
import { getOptionalFiles } from "services/sandbox-api/transforms";
import { activeFileSelector, addSandboxFiles, deleteSandboxFiles, openFile, renameSandboxFiles, setEntry } from "store/features";
import { useAppDispatch, useAppSelector } from "store/hooks";
import styles from "./Explorer.module.css";

interface FileExplorerProps {
  onCollapse: () => void;
}

export const FileExplorer = ({ onCollapse }: FileExplorerProps) => {
  const dispatch = useAppDispatch();
  const layout = useAppSelector((state) => state.settings.layout);
  const sourceFiles = useAppSelector((state) => state.activeSandbox.sourceFiles)
  const optionalFiles = useAppSelector((state) => state.activeSandbox.optionalFiles)
  const state = useAppSelector(activeFileSelector);
  const [newFile, setNewFile] = useState(false);
  const [newFolder, setNewFolder] = useState(false);
  const [upload, setUpload] = useState(false);

  const closeDialog = () => {
    setNewFile(false);
    setNewFolder(false);
    setUpload(false);
  }

  const callbacks = useMemo<FileExplorerCallbacks>(() => {
    return {
      onSelect: (filePath) => dispatch(openFile({ filePath })),
      onFileAdded: (filePath, type, openInEditor, content) => {
        dispatch(addSandboxFiles({ filePath, type, content }));
        closeDialog();
        if (openInEditor)
          dispatch(openFile({ filePath }));
      },
      onFileRemoved: (filePath) => dispatch(deleteSandboxFiles(filePath)),
      onRenamed: (filePath) => dispatch(renameSandboxFiles(filePath)),
      onEntryChange: (filePath) => dispatch(setEntry(filePath)),
      onClose: closeDialog
    }
  }, [dispatch]);

  return (
    <div className={styles.fileExplorerPanel}>
      {layout.toolbars !== false &&
        <Toolbar expanded={true} onCollapse={onCollapse} onNewFile={() => setNewFile(true)} onNewFolder={() => setNewFolder(true)} onUpload={() => setUpload(true)} />}
      <ExplorerMemo
        files={[...sourceFiles, ...getOptionalFiles(optionalFiles)]}
        filePathSelected={state?.activeFile?.filePathRenamed ?? state?.activeFile?.filePath}
        newFile={newFile}
        newFolder={newFolder}
        upload={upload}
        callbacks={callbacks}
      />
    </div>
  )
}